import script from "./YuvcView.vue?vue&type=script&setup=true&lang=js"
export * from "./YuvcView.vue?vue&type=script&setup=true&lang=js"

import "./YuvcView.vue?vue&type=style&index=0&id=802b3752&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-802b3752"]])

export default __exports__